import { motion } from "framer-motion";
import { t } from "../i18n";
import { fadeUp, stagger, viewport } from "../motion";

export default function Process() {
  const p = t.de.process;
  return (
    <section id="process" data-testid="process" className="py-24 md:py-36 bg-white">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="max-w-2xl mb-16">
          <motion.div variants={fadeUp} className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-gold-500" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-600">{p.overline}</span>
          </motion.div>
          <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-navy-900 leading-tight">
            {p.title}
          </motion.h2>
        </motion.div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.15 }} className="relative">
          <div className="absolute left-[27px] md:left-0 md:top-[54px] top-0 md:w-full w-px md:h-px h-full bg-gradient-to-b md:bg-gradient-to-r from-gold-200 via-gold-400 to-gold-200" />
          <div className="grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-6">
            {p.steps.map((step, i) => (
              <motion.div key={i} variants={fadeUp} data-testid={`process-step-${i}`} className="relative flex md:flex-col gap-5 md:gap-0 pl-0">
                <div className="relative z-10 w-14 h-14 shrink-0 rounded-full bg-white border-2 border-gold-400 flex items-center justify-center md:mb-8">
                  <span className="text-lg font-outfit font-medium text-gold-600">{i + 1}</span>
                </div>
                <div>
                  <h3 className="text-lg font-outfit font-medium text-navy-900">{step.t}</h3>
                  <p className="mt-2 text-slate-500 leading-relaxed text-[15px]">{step.d}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
